import { FC, ReactElement, useMemo } from 'react'

import { Button } from '@/components'
import { IconButton } from '@/compositions'
import { getCalendarNavigationDateInputLabel } from '@/compositions/DateNavigator/helpers'
import { trans } from '@/helpers/trans'
import { TimeModeType } from '@/types'

import './DateControls.scss'

interface DateControlsProps {
    selectedDays: Date[]
    timeMode: TimeModeType
    onDayPickerButtonClick: () => void
    onIncrementButtonClick: (goForward: boolean) => void
    className?: string
}

export const DateControls: FC<DateControlsProps> = ({
    selectedDays,
    timeMode,
    onDayPickerButtonClick,
    onIncrementButtonClick,
    className = '',
}): ReactElement => {
    const datePickerButtonText = useMemo(() => getCalendarNavigationDateInputLabel(selectedDays, timeMode), [selectedDays])

    const handleNextButtonClick = () => {
        onIncrementButtonClick(true)
    }

    const handlePreviousButtonClick = () => {
        onIncrementButtonClick(false)
    }

    return (
        <div className={`date-controls ${className}`}>
            <IconButton
                hideLabel
                icon="chevron-left"
                text={trans('common.previous')}
                onClick={handlePreviousButtonClick}
                className="date-controls__prev-button"
            />

            <Button
                text={datePickerButtonText}
                onClick={onDayPickerButtonClick}
                className="date-controls__date-picker-button"
            />

            <IconButton
                hideLabel
                icon="chevron-right"
                text={trans('common.next')}
                onClick={handleNextButtonClick}
                className="date-controls__next-button"
            />
        </div>
    )
}
